<template>
  <div>
    <Heading heading="Assignment Submission Settings" />
    <!-- Assignment Resubmission -->
    <div class="flex justify-between items-center">
      <Heading heading="Assignment Resubmission" heading-size="text-base" />
      <ToggleButton v-model="settings.assignment_resubmission_allowed" :is-status-hide="true" />
    </div>
    <Divider />
    <!-- Submission Description Required -->
    <div class="flex justify-between items-center">
      <Heading heading="Submission Description Required" heading-size="text-base" />
      <ToggleButton v-model="settings.submission_description_required" :is-status-hide="true" />
    </div>
    <Divider />
    <!-- Assignment Acceptance -->
    <div class="flex justify-between items-center">
      <Heading heading="Assignment Acceptance" heading-size="text-base" />
      <div class="flex items-center gap-2">
        <UiCheckBox
          name="Single"
          :model-value="assignmentRequiredOption === 'single'"
          lable-direction="flex-row-reverse"
          label="Single"
          type="radio"
          value="single"
          @change="updateassignmentRequiredOptionStatus"
        />
        <UiCheckBox
          name="Multiple"
          label="Multiple"
          type="radio"
          lable-direction="flex-row-reverse"
          :model-value="assignmentRequiredOption === 'multiple'"
          value="multiple"
          @change="updateassignmentRequiredOptionStatus"
        />
        <UiCheckBox
          name="One to Multiple"
          label="One to Multiple"
          type="radio"
          lable-direction="flex-row-reverse"
          :model-value="assignmentRequiredOption === 'one_to_multiple'"
          value="one_to_multiple"
          @change="updateassignmentRequiredOptionStatus"
        />
      </div>
    </div>
    <Divider />
    <!-- Attachment File Type -->
    <div class="flex justify-between items-center">
      <Heading heading="Attachment File Type" heading-size="text-base" />
      <div class="flex items-center gap-2">
        <UiCheckBox
          v-for="(CheckBox, i) in typeCheckBox"
          :key="i"
          :model-value="assignmentTypes.includes(CheckBox.title)"
          lable-direction="flex-row-reverse"
          :name="CheckBox.title"
          :label="CheckBox.title"
          :value="CheckBox.title"
          @change="updateAttachmentType($event, CheckBox.format)"
        />
      </div>
    </div>
    <!-- Assignment Required -->
  </div>
</template>

<script setup>
import { ref, watch, reactive } from 'vue'

// Components
import Heading from '@src/components/Heading.vue'
import ToggleButton from '@src/components/BaseComponent/toggleButton.vue'
import UiCheckBox from '@src/components/UiElements/UiCheckbox.vue'
import Divider from '@src/components/Divider.vue'
import FILE_CONSTANTS from '@src/constants/file-constants.js'
const props = defineProps({ modelValue: { default: () => {}, type: Object } })

const emits = defineEmits(['update:modelValue'])

// States
let settings = reactive({
  assignment_resubmission_allowed: false,
  attachment_required: null,
  attachment_file_type: [],
  submission_description_required: false,
  file_accept_format: '',
})
let assignmentRequiredOption = ref('')
let assignmentTypes = ref([])
const typeCheckBox = ref([
  FILE_CONSTANTS.Zip,
  FILE_CONSTANTS.PDF,
  FILE_CONSTANTS.DOCX,
  FILE_CONSTANTS.PNG,
])
// watch

watch(
  settings,
  (value) => {
    emits('update:modelValue', value)
  },
  { immediate: true },
)

watch(
  () => props.modelValue,
  (newValue) => {
    settings = newValue
    assignmentRequiredOption.value = newValue.attachment_required
    assignmentTypes.value = newValue.attachment_file_type
    emits('update:modelValue', settings)
  },
)
const updateassignmentRequiredOptionStatus = (ev) => {
  if (ev.status) {
    assignmentRequiredOption.value = ev.value
    settings.attachment_required = ev.value
  }
}
const updateAttachmentType = (ev, format) => {
  if (settings.file_accept_format === 'null') {
    settings.file_accept_format = ''
  }
  if (ev.status) {
    assignmentTypes.value.push(ev.value)
    settings.file_accept_format += `${format}, `
  } else {
    settings.file_accept_format = settings.file_accept_format.replace(`${format}, `, '')

    const index = assignmentTypes.value.indexOf(ev.value)
    if (index !== -1) {
      assignmentTypes.value.splice(index, 1)
    }
  }
  settings.attachment_file_type = assignmentTypes.value
}
</script>
